import { NgModule } from '@angular/core';
import {  SearchGotraPipe } from './search/search';
import { IndianCurrency } from './IndianCurrency.pipe';
import { SearchNakshatraPipe } from './search/searchnakshatra';
import { SearchVedaPipe } from './search/searchveda';
@NgModule({
	declarations: [SearchGotraPipe,SearchNakshatraPipe,IndianCurrency, SearchVedaPipe],
	imports: [],
	exports: [SearchGotraPipe,SearchNakshatraPipe,IndianCurrency, SearchVedaPipe]
})
export class PipesModule {}	


// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts